
import Layout from "@/components/Layout";
import ExploreProvidersContainer from "@/components/explore/ExploreProvidersContainer";

const ExploreProvidersPage = () => {
  return (
    <Layout>
      <ExploreProvidersContainer />
    </Layout>
  );
};

export default ExploreProvidersPage;
